export default "__VITE_ASSET__HYsCZ6Lu__"